(() => {
  const home = document.getElementById('autotech-search-ymm-home');
  const finder = document.getElementById('autotech-search-ymm');
  if (!home || !finder) return;

  let pendingFocus = null;
  let scheduled = false;
  let wasOpen = false;
  let lastTrigger = null;

  const sync = () => {
    scheduled = false;
    const popup = document.getElementById('glFilter-search-popup');
    const header = popup?.querySelector('.gl-fullscreen-header');
    const isOpen = Boolean(header && popup.getAttribute('aria-hidden') !== 'true');

    if (isOpen) {
      const layer = header.closest('.gl-fullscreen-layer');
      let keyword = layer.querySelector('.autotech-keyword-panel');
      if (!keyword) {
        keyword = document.createElement('section');
        keyword.className = 'autotech-keyword-panel';
        keyword.setAttribute('aria-labelledby', 'autotech-keyword-heading');
        keyword.append(document.getElementById('autotech-keyword-intro').content.cloneNode(true));
        layer.prepend(keyword);
      }
      if (header.parentElement !== keyword) keyword.append(header);
      let results = keyword.querySelector('.autotech-keyword-results');
      if (!results) {
        results = document.createElement('div');
        results.className = 'autotech-keyword-results';
        keyword.append(results);
        const hint = document.createElement('button');
        hint.type = 'button';
        hint.className = 'autotech-results-scroll-hint';
        hint.textContent = `${home.dataset.scrollLabel} ↓`;
        hint.setAttribute('aria-controls', 'autotech-keyword-results');
        results.id = 'autotech-keyword-results';
        keyword.append(hint);
        const updateScrollHint = () => {
          hint.hidden = results.scrollHeight - results.clientHeight - results.scrollTop < 8;
        };
        results.addEventListener('scroll', updateScrollHint, { passive: true });
        hint.addEventListener('click', () => results.scrollBy({
          top: results.clientHeight * 0.75,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        }));
        new ResizeObserver(updateScrollHint).observe(results);
        results.updateScrollHint = updateScrollHint;
      }
      layer.querySelectorAll('.gl-fullscreen-suggestions, .gl-fullscreen-initial-content').forEach(node => {
        if (node.parentElement !== results) results.append(node);
      });
      if (finder.parentElement !== layer) layer.append(finder);
      results.updateScrollHint?.();
      popup.classList.add('autotech-unified-search');
    } else if (finder.parentElement !== home) {
      home.append(finder);
    }

    document.querySelectorAll('[data-globo-search-activator]').forEach(button => {
      button.setAttribute('aria-expanded', String(isOpen));
    });

    finder.querySelectorAll('select[id]').forEach(select => {
      if (select.id.startsWith('autotech-search-')) return;
      const previousId = select.id;
      select.id = `autotech-search-${previousId}`;
      finder.querySelectorAll('label[for]').forEach(label => {
        if (label.htmlFor === previousId) label.htmlFor = select.id;
      });
    });

    const submit = finder.querySelector('button[type="submit"]');
    if (submit && submit.textContent !== finder.dataset.submitLabel) submit.textContent = finder.dataset.submitLabel;
    const loaded = Boolean(finder.querySelector('select'));
    finder.classList.toggle('is-loaded', loaded);
    if (pendingFocus && !pendingFocus.element.isConnected && loaded && isOpen) {
      const control = [...finder.querySelectorAll('select')].find(el => el.name === pendingFocus.name);
      if (control && (document.activeElement === document.body || !document.activeElement?.isConnected)) {
        control.focus({ preventScroll: true });
      }
      pendingFocus = null;
    }
    if (wasOpen && !isOpen && document.activeElement === document.body && lastTrigger?.isConnected) {
      lastTrigger.focus({ preventScroll: true });
    }
    wasOpen = isOpen;
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  };

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-globo-search-activator]');
    if (trigger) lastTrigger = trigger;
  }, true);

  finder.addEventListener('change', event => {
    if (event.target.matches('select')) pendingFocus = { name: event.target.name, element: event.target };
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const popup = document.getElementById('glFilter-search-popup');
    if (!popup?.contains(document.activeElement) || !popup.contains(finder)) return;
    const input = popup.querySelector('#gl-d-searchbox-input');
    const close = popup.querySelector('.gl-d-close-btn');
    const controls = [
      input,
      ...popup.querySelectorAll('.gl-fullscreen-initial-content a[href]:not([aria-hidden="true"]), .gl-fullscreen-suggestions a[href]'),
      popup.querySelector('.autotech-results-scroll-hint'),
      ...finder.querySelectorAll('select, button, input:not([type="hidden"]), a[href]'),
      close,
    ].filter(el => el && !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
    if (!controls.length) return;
    const index = controls.indexOf(document.activeElement);
    const next = event.shiftKey ? (index <= 0 ? controls.length - 1 : index - 1) : (index + 1) % controls.length;
    event.preventDefault();
    event.stopImmediatePropagation();
    input?.removeAttribute('aria-activedescendant');
    controls[next].focus();
  }, true);

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('globoFilterSearchDrawerOpened', schedule);
  window.addEventListener('globoFilterRenderCompleted', schedule);
  window.addEventListener('globoFilterRenderSearchCompleted', schedule);
  sync();
})();
